"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableColumn = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _expander = require("../../expander");

var _layout = require("../../layout");

var _html = require("../html");

var _interfaces = require("../interfaces");

var _utils = require("./utils");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ExpandableColumn = function ExpandableColumn(_ref) {
  var actionColumnIndex = _ref.actionColumnIndex,
      ariaLabel = _ref.ariaLabel,
      colIndex = _ref.colIndex,
      columns = _ref.columns,
      expandableRowHasTopBorder = _ref.expandableRowHasTopBorder,
      expandableRowIndex = _ref.expandableRowIndex,
      isActionCustomPosition = _ref.isActionCustomPosition,
      isExpanded = _ref.isExpanded,
      isSorted = _ref.isSorted,
      isStriped = _ref.isStriped,
      spacing = _ref.spacing,
      data = _ref.data,
      columnProps = _ref.columnProps;
  var _columnProps$dataCell = columnProps.dataCellType,
      dataCellType = _columnProps$dataCell === void 0 ? _interfaces.CellType.Data : _columnProps$dataCell,
      getCellExpandableContent = columnProps.expandableContent,
      textAlign = columnProps.textAlign,
      width = columnProps.width;
  var isCellTypeHeader = dataCellType === _interfaces.CellType.Header;
  var Cell = isCellTypeHeader ? _html.ThElement : _html.TdElement;
  var dataTypeCellProps = isCellTypeHeader ? {
    scope: 'row'
  } : {}; // expandableRowIndex might be out of bounds but that is ok as it's handled like an empty cell

  var ExpandableCellContent = (0, _react.useMemo)(function () {
    return !!getCellExpandableContent && getCellExpandableContent({
      data: data,
      index: colIndex
    })[expandableRowIndex];
  }, [expandableRowIndex, getCellExpandableContent, data, colIndex]);
  return !!ExpandableCellContent ? (0, _core.jsx)(_react.default.Fragment, null, // Add an empty cell if actionColumnIndex is set and is matches the index of the current column
  isActionCustomPosition && actionColumnIndex === colIndex && (0, _core.jsx)(_html.TdElement, null), (0, _core.jsx)(Cell, (0, _extends2.default)({
    isStriped: isStriped,
    textAlign: textAlign,
    width: width,
    "aria-label": ariaLabel,
    verticalAlign: "top"
  }, dataTypeCellProps), (0, _core.jsx)(_expander.ExpanderContent, {
    isExpanded: isExpanded,
    shouldAnimateImmediately: isSorted,
    topSpacing: expandableRowHasTopBorder ? (0, _utils.getVerticalSpacingForCell)(spacing) : undefined
  }, (0, _core.jsx)(_layout.View, {
    padding: {
      bottom: (0, _utils.getVerticalSpacingForCell)(spacing)
    }
  }, ExpandableCellContent))), // Add an empty action cell if actionColumnIndex points to the last column
  !!actionColumnIndex && colIndex === columns.length - 1 && actionColumnIndex - 1 >= colIndex && (0, _core.jsx)(_html.TdElement, null)) : (0, _core.jsx)(Cell, {
    key: colIndex
  });
};

exports.ExpandableColumn = ExpandableColumn;